<template>
  <section>
    <v-stepper v-model="stepper" v-if="study_group">
      <v-stepper-header>
        <v-stepper-step :complete="stepper > 1" step="1">Booking policy</v-stepper-step>

        <v-divider></v-divider>
        <v-stepper-step :complete="stepper > 2" step="2">Course package</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3">Finish</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-sheet class="overflow-y-auto" max-height="400px">
            <v-card-text class="ql-editor" v-html="study_group.booking_policy"></v-card-text>
          </v-sheet>
          <v-divider/>
          <v-card-actions>
            <v-btn text @click="$router.back()">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="stepper++">I accept the Booking Policy</v-btn>
          </v-card-actions>
        </v-stepper-content>

        <v-stepper-content step="2">

          <v-select label="Choose package"
                    class="mt-1"
                    v-model="course_package_id"
                    :items="course_packages"
                    item-text="name"
                    item-value="id"
                    color="primary"
                    item-color="primary"
                    :error-messages="api_errors['course_package_id']"
                    outlined
          >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
                <v-list-item-subtitle>Price: {{ item.price }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action class="text-left">
                <p class="my-0" v-for="(st, idx) in item.session_types" :key="idx">
                  {{ st.name }} {{ st.count }}
                </p>
              </v-list-item-action>
            </template>
            <template v-slot:selection="{ item }">
              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
                <v-list-item-subtitle>Price: {{ item.price }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action class="text-left">
                <v-list-item-subtitle class="" v-for="(st, idx) in item.session_types" :key="idx">
                  {{ st.name }} {{ st.count }}
                </v-list-item-subtitle>
              </v-list-item-action>
            </template>
          </v-select>

          <v-divider/>
          <v-card-actions>
            <v-btn color="primary" @click="stepper--">Back</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" :disabled="!course_package_id" @click="buyCoursePackage">Buy</v-btn>
<!--            <v-btn text @click="stepper++">Skip >></v-btn>-->
          </v-card-actions>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-select label="OSCE P1 exam dates"
                    v-model="study_sub_group_id"
                    :items="study_group.study_sub_groups"
                    item-value="id"
                    item-text="p1_exam_dates"
                    prepend-icon="mdi-account-group"
          >
            <template v-slot:item="{ item }">
              <span class="font-weight-bold">{{ item.name }} - </span>
              <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">
                      {{ $moment(exam_date).format('DD/MM/YYYY') }},
                    </span>
            </template>

            <template v-slot:selection="{ item }">
              <span class="font-weight-bold">{{ item.name }} - </span>
              <span v-for="(exam_date, idx) in  item.p1_exam_dates" :key="idx" class="mx-1">
                      {{ $moment(exam_date).format('DD/MM/YYYY') }},
                    </span>
            </template>
          </v-select>

          <v-select id="firstQuestion"
                    v-model="first_answer"
                    :items="first_answer_options"
                    :label="first_question"
          />

          <v-switch class="mx-3" label="Is Sunday your day off?" v-model="sunday_day_off"/>

          <template v-if="first_answer === 'working' || first_answer === 'working_before_exam'">
            <v-subheader>Indicate any time off work/studies within your preparation period when you are available for mock sessions 7 days a week</v-subheader>
            <date-field v-model="training_start" label="From"/>
            <date-field v-model="training_end" label="Till"/>
          </template>

          <v-textarea outlined v-model="summary" color="primary" class="my-0" label="Motivation letter"/>
          <v-divider/>

          <v-card-actions>
            <v-btn color="primary" @click="stepper--">Back</v-btn>
            <v-spacer/>
            <v-btn color="success" @click="joinStudyGroup">Next</v-btn>
          </v-card-actions>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </section>
</template>

<script>
import DateField from "@/components/DateField";
export default {
  components: {DateField},
  props: {
    study_group: {
      type: Object,
      default: null
    }
  },
  data:() => ({
    stepper: 1,
    course_packages: [],

    first_question: 'Please indicate your availability for exam preparation',
    first_answer_options: [
      {
        text: 'I am flexible (freelancer) or I do not work at all and won’t be working until/after the exam',
        value: 'not_working',
      },
      {
        text: 'I work all working days, and will get less than 2 weeks off work before the exam',
        value: 'not_intensive_working',
      },
      {
        text: 'I work all working days, but will get more than 2 weeks off work before the exam',
        value: 'working',
      },
      {
        text: 'I am not working now, but will get back to work closer to the exam time',
        value: 'working_before_exam',
      },
    ],
    course_package_id: null,
    study_sub_group_id: null,
    sunday_day_off: false,
    training_start: '',
    training_end: '',
    summary: '',
    first_answer: '',
    api_errors: [],
  }),
  computed: {
    visitation_type: function () {
      if (this.first_answer === 'working' || this.first_answer === 'working_before_exam') {
        return 'G3'
      }
      return this.first_answer === 'not_working' ? 'G1' : 'G2'
    },
  },

  created() {
    this.loadPackages()
  },
  methods: {
    async loadPackages() {
      this.course_packages = await this.axios.get('api/packages').then(({data}) => data.data)
    },
    buyCoursePackage() {
      this.api_errors = []
      this.app_loading = true
      this.axios.post(`api/invoices`, {course_package_id: this.course_package_id})
          // eslint-disable-next-line no-unused-vars
          .then(({data}) => {
            // console.log(data)
            this.stepper++
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {this.app_loading = false})
    },
    joinStudyGroup() {
      this.api_errors = []
      this.app_loading = true
      this.axios.post(`api/user/study-groups`, {
        study_group_id: this.study_group.id,
        study_sub_group_id: this.study_sub_group_id,
        visitation_type: this.visitation_type,
        sunday_day_off: this.sunday_day_off,
        training_start: this.training_start,
        training_end: this.training_end,
        summary: this.summary,
      })
          .then(() => {
            this.$notify('Success!', 'success')
            this.$store.dispatch('loadAuthUserStudyGroups')
            this.$router.push({name: 'Study group', params: this.$route.params})
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {this.app_loading = false})
    }
  }
}
</script>